import { createRef, useContext } from "react";
import JSONSchemaForm from "@rjsf/core";
import useGet from "./useGet";
import useUpdate from "./useUpdate";
import { ConfigurationActionContext } from "./ConfigurationActionContext";
import { useNavigate } from "react-router-dom";
import ProducerForm from "@main/producers/components/ProducerForm";
import { TenantAndCommerceContext } from "@main/contexts/TenantAndCommerceContext";
import { showSuccessMessage } from "@beeldit/core/helpers/messagesHelper";
import ConfigurationProducerForm from "@main/producers/components/ConfigurationProducerForm";

function useConfigurationAction(id: number, formDefaultValues: any = {}): any {
  const navigate = useNavigate();

  const { tenantId, commerceId } = useContext(TenantAndCommerceContext);

  const configurationFunction = (id: any) => {
    navigate(`/panel/${tenantId}/${commerceId}/producers/${id}`);
  };

  const get = useGet();
  const getFunction = (id: number) => get(id);

  /**
   * Form store success function definition
   */

  const onSuccessUpdate = () => {
    showSuccessMessage("successfull_action");
    getFunction(id); // We pass the function to refresh the table on success
  };

  const update = useUpdate();
  const updateFunction = () => update(onSuccessUpdate);

  /** Edition element definition */
  const { element } = useContext(ConfigurationActionContext);

  /**
   * Form Reference definition
   */
  const formRef = createRef<JSONSchemaForm>();

  const onSubmitFunction = () =>
    formRef.current?.formElement.current.requestSubmit(); //We pass the function for the submit of the modal

  /**
   * Form configuration definition
   */
  const formConfig = {
    formRef: formRef, // We pass the ref to the form
    onSubmit: () => {
      updateFunction();
    },
    element: element, // We pass the element to the form in order to render it in the modal form
    context: ConfigurationActionContext,
    action: "edit",
    className: "producer-form",
    formDefaultValues: formDefaultValues,
  };

  const actionTemplate = <ConfigurationProducerForm formConfig={formConfig} />;

  /** END EDIT FORM ACTION */

  return {
    configurationFunction,
    getFunction,
    onSubmitFunction,
    actionTemplate,
  };
}

export default useConfigurationAction;
